import { Instance, types } from "mobx-state-tree";

export const NetworkingModel = types.model({
  dnsForwarder: types.optional(types.string, ""),
  serviceNetwork: types.optional(types.string, ""),
  podNetwork: types.optional(types.string, ""),
});
export interface NetworkingMobx extends Instance<typeof NetworkingModel> {}
export interface Networking {
  dnsForwarder: string;
  serviceNetwork: string;
  podNetwork: string;
}
